import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss']
})
export class AppShellComponent implements OnInit, OnDestroy {
  @Output() openFirmPicker = new EventEmitter<void>();

  showSideNav = true;

  private readonly destroy$ = new Subject<void>();
  private readonly authRoutes = ['/auth/login', '/auth/signup', '/auth/reset', '/auth/forgot', '/auth/error'];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateSideNavVisibility(this.router.url);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event) => {
        this.updateSideNavVisibility(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateSideNavVisibility(url: string): void {
    this.showSideNav = !this.authRoutes.some((route) => url.startsWith(route));
  }
}
